import { FolderDocument } from '../server/folder-document';

export class FolderDocumentsRefreshEvent {
    public constructor(
        public folderId: string,
        public documents: FolderDocument[],
        /**
         * Id du document à selectionner (facultatif)
         */
        public selectedDocumentId: string = null,

        public deleted: boolean = false
    ) {}
}
